import { render, staticRenderFns } from "./couches-a45.vue?vue&type=template&id=4d0feb2a&"
import script from "./couches-a45.vue?vue&type=script&lang=js&"
export * from "./couches-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports